<template>
  <SfProperty
    v-if="attribute.frontent_input != 'boolean'"
    class="a-product-attribute"
    :name="label | htmlDecode"
    :value="attributeValue"
  />
</template>

<script>
import { SfProperty } from '@storefront-ui/vue';
import { ProductAttribute } from '@vue-storefront/core/modules/catalog/components/ProductAttribute';

export default {
  name: 'AProductAttribute',
  mixins: [ProductAttribute],
  components: {
    SfProperty
  },
  computed: {
    attributeValue () {
      if (this.attribute.frontend_input === 'boolean') {
        return (this.product[this.attribute.attribute_code]) ? 'ja' : 'nein'
      }
      return this.value
    }
  }
};
</script>
